// Single source of truth for study_resource_type_master.TypeId values the
// Study Resource form supports. Mirrors nodefork's study-resource-type.constant.ts.
//
// Discussion Board (20) lives in study_discussion_board (linked by Id; no FK) and
// is dual-written by the backend create flow.

export const STUDY_RESOURCE_TYPE = {
  DOWNLOAD: 1,
  REFERENCE: 5,
  ARTICLE: 6,
  EBOOK: 13,
  DISCUSSION_BOARD: 20,
  VIMEO: 31,
  YOUTUBE: 32,
  ONLINE_TEST: 36,
  CODE_EDITOR: 37,
  INTERACTIVE_PATHWAY: 40,
  SPIN_WHEEL: 41,
} as const;

/** All TypeIds the Study Resource form can edit. */
export const STUDY_RESOURCE_TYPE_IDS: readonly number[] = Object.values(STUDY_RESOURCE_TYPE);

/**
 * ScormCourse (27) is deliberately NOT in STUDY_RESOURCE_TYPE / _IDS: SCORM
 * resources are created by the /scorm-courses upload wizard (SCORM Cloud
 * import), never by this form. The form shows a pointer to the library instead.
 */
export const SCORM_COURSE_TYPE_ID = 27;
